// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"help","160":"tcp"}[chunkId] + "." + {"22":"3c7a7ce7","160":"5b4f90ee"}[chunkId] + ".js";
};